<!doctype html>
<!--
                 None (auto)	 540px	     720px	     960px	     1140px
Class prefix	.col-	        .col-sm-	.col-md-	.col-lg-	.col-xl-
col-sm- col-md- col.lg- col-xl-
-->

<main>
    <div class="container-general-home">


        <div class="presentation-section p-3">

            <p>Hi! </p>

            <h2 class="">Mi nombre es Patricia Valdebenito</h2>

            <hr>

            <h1 class="">Front End Developer</h1>
            <br>

            <p>Te invito a conocer mis proyectos </p>
            <a class="btn btn-block mb-1 button-home-project" routerLink="/project">Proyectos</a>

        </div>



        <div class="container-logo-contact py-3">
            <section class="section-contact-home  py-3">
                <a href="https://github.com/Patriciavaldebenito" target="_blank">
                    <i class="fab fa-github"></i>
                </a>

                <a href="mailto:patricia.vpanes@gmail.com">
                    <i class="far fa-envelope"></i>
                </a>
                <a href="https://www.linkedin.com/in/patricia-valdebenito" target="_blank">
                    <i class="fab fa-linkedin"></i>
                </a>
            </section>
        </div>




    </div>
</main>